import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  /** When true the container renders as a centered full-screen overlay */
  full?: boolean;
  /** When true and `full` is true, the overlay will be full-bleed (use entire viewport for content) */
  fullBleed?: boolean;
}

function Container({
  children,
  className = '',
  full = false,
  fullBleed = false,
}: ContainerProps) {
  if (full) {
    // Full-bleed overlay (content occupies entire viewport)
    if (fullBleed) {
      return (
        <div
          className={`fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm ${className}`}
        >
          {children}
        </div>
      );
    }

    // Default centered card overlay
    return (
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6 ${className}`}
      >
        <div className="w-full max-w-3xl rounded-xl bg-white p-6 shadow-lg">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className={`container mx-auto px-4 sm:px-6 ${className}`}>
      {children}
    </div>
  );
}

export default Container;
